<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Approve Client {{ (invoice.type === 'credit') ? 'Credit' : 'Invoice' }}</p>
      </header>
      <section class="modal-card-body">
        <b-message type="is-info">
          <p class="mb-lg">Approving this transaction will commit changes to funding balances and may notify project leaders.</p>
          <p class>Are you sure you want to approve this transaction?</p>
        </b-message>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >Approve {{ (invoice.type === 'credit') ? 'Credit' : 'Invoice' }}</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api'])
  },
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/admin/client-invoices/' + this.invoice.id + '/approve'
      this.$http.put(endpoint).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-success', message: 'Invoice approved!' })
        this.$emit('invoice:approved', response.data)
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: {
    invoice: {
      type: Object,
      required: true
    }
  }
}
</script>
